/**
 * CandyOnline QLS Stock Guard v2
 *
 * Storefront-laag die het echte QLS-voorraad ophaalt en het UI overrijdt.
 *
 * v2 changes:
 *   - Ondersteunt naast data-sku ook data-variant-id (Shopify standaard)
 *   - Verbergt hele product-cards bij OOS (display:none) ipv alleen knop disablen
 *   - Werkt op PDP, collection-pagina's, /pages/*, search, en custom landings
 *
 * Hard limits:
 *   - 500ms timeout per fetch (fail-open)
 *   - max 100 items per batch-call
 *   - debounce 1.5s tussen DOM-mutation rescans
 *
 * Endpoint:
 *   https://admin.candyonline.nl/voorraad-public.php?skus=...&variants=...
 *
 * Console: window.QLS_GUARD_DEBUG = true voor verbose logging.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://admin.candyonline.nl/voorraad-public.php';
  // Uitzonderingen: producten die op preorder lopen of waarvan het endpoint
  // aantoonbaar verkeerde data geeft. De guard laat deze volledig met rust;
  // Shopify's eigen voorraad/policy bepaalt dan de koopbaarheid.
  // 206588 / 53898853318983 = Felko Trekdrop 5 Kilo (endpoint gaf vals 0, preorder per 2026-06-11).
  // 206588-35 / 54135859609927 = Felko Trekdrop 3,5 Kilo bundel (7x 500g; Shopify fixed bundle,
  //   voorraad komt uit de componenten; QLS kent de parent-SKU niet en hoeft die ook niet te kennen).
  // 20029 / 53184178192711 = Felko Strekdrop 500g (preorder per 2026-06-15).
  // 20060 / 53288360182087 = MEGA Snoepmix 1 Kilo / 2 euro-deal (preorder per 2026-06-15).
  // 3043 / 52736587759943 = Swedish Fish Assorted Box (variant-lookup gaf vals found:false/0 terwijl
  //   SKU 3043 in QLS wel 1324 op voorraad heeft; alleen de variant->SKU-map van het endpoint is stale).
  // 206609-206621 / Monster The Beast (13 alcohol-blikken) = auto-preorder via tag 'preorder-when-oos'
  //   + inventory_policy CONTINUE (per 2026-06-19). Guard laat ze volledig met rust (grids, PDP en checkout);
  //   het thema toont zelf de pre-order-UI zodra de Shopify-voorraad 0 is. Leverdag = shop-metafield
  //   candyonline.preorder_label. Nieuw blik op deze regeling? -> SKU + variant-id hieronder toevoegen.
  // 20683-4 / 54469635539271 = Red Bull 4-Pack welkomstaanbieding (4x componentvariant 54361082593607 /
  //   SKU 20683, Shopify fixed bundle; voorraad komt uit de component en QLS kent de
  //   parent-SKU niet. Let op: component-SKU 20683 blijft WEL bewaakt, dat is een
  //   normaal voorraadproduct dat los verkocht wordt.
  // 20679-REG / 54469711331655 = Red Bull Winter Edition Fuji 12 blikjes, de NORMALE listing
  //   naast de welkomstdeal (1x componentvariant 54347383767367 / SKU 20679, Shopify fixed
  //   bundle). Beide listings tappen uit dezelfde QLS-voorraad; QLS kent de parent-SKU niet.
  // 20706 / 54477085081927 = Red Bull Glacier Edition 24 blikjes: pre-order sept 2026 (tag preorder-when-oos +
  //   CONTINUE via preorder-window.php); endpoint geeft 0 zolang de voorraad niet binnen is, Shopify bepaalt de koopbaarheid.
  var EXEMPT_SKUS = { '20670': true, '206588': true, '206588-35': true, '20683-4': true, '20679-REG': true, '20029': true, '20060': true, '20706': true,
    '206609': true, '206610': true, '206611': true, '206612': true, '206613': true, '206614': true, '206615': true,
    '206616': true, '206617': true, '206618': true, '206619': true, '206620': true, '206621': true };
  var EXEMPT_VARIANTS = { '54295952228679': true, '53898853318983': true, '54135859609927': true, '54469635539271': true, '54469711331655': true, '53184178192711': true, '53288360182087': true, '52736587759943': true, '54477085081927': true,
    '54053585977671': true, '54053564383559': true, '54053634441543': true, '54053642142023': true, '54053648793927': true,
    '54053656363335': true, '54053695422791': true, '54053704139079': true, '54053722161479': true, '54053726060871': true,
    '54053729009991': true, '54053740216647': true, '54053748834631': true };
  // Sinds 2026-09-19 komt de pre-orderlijst ook uit de winkeldata: snippets/preorder-notice.liquid
  // rendert window.__PREORDER_GUARD_EXEMPT__ (SKU's + variant-id's van elk product in het
  // shop-metafield candyonline.preorder_overrides, beheerd vanuit Vantage/Pre order). Lazy
  // gelezen bij elke check, zodat de laadvolgorde er niet toe doet. De hardcoded lijsten
  // hierboven blijven gelden voor de oude gevallen (deal-tweelingen, Monster-blikken).
  function dataExempt() {
    var d = window.__PREORDER_GUARD_EXEMPT__;
    return (d && typeof d === 'object') ? d : null;
  }
  function inLijst(lijst, waarde) {
    if (!lijst || !lijst.length) return false;
    for (var i = 0; i < lijst.length; i++) { if (lijst[i] && String(lijst[i]) === String(waarde)) return true; }
    return false;
  }
  function isExemptSku(sku) {
    if (EXEMPT_SKUS[sku]) return true;
    var d = dataExempt();
    return !!(d && inLijst(d.skus, sku));
  }
  function isExemptVariant(vid) {
    if (EXEMPT_VARIANTS[vid]) return true;
    var d = dataExempt();
    return !!(d && inLijst(d.variants, vid));
  }
  var FETCH_TIMEOUT_MS = 1500;
  var BATCH_MAX = 100;
  var DEBOUNCE_MS = 1500;
  var OOS_LABEL = 'Uitverkocht';
  var OOS_ALERT = 'Dit product is helaas niet meer leverbaar.';
  // Selectors die we als "card-container" zien - bij OOS van het inner data-variant-id/data-sku
  // element wordt het closest matching element gehidden.
  var CARD_SELECTORS = [
    'article.hs-card',
    '.hs-card',
    '.product-card',
    '.product-card-wrapper',
    '.card-wrapper',
    '.grid__item',
    '.product-grid-item',
    '.js-product-card',
    'product-card',
    '[data-product-card]'
  ].join(',');

  function log() { if (window.QLS_GUARD_DEBUG) console.log.apply(console, ['[qls-guard]'].concat([].slice.call(arguments))); }
  function warn() { console.warn.apply(console, ['[qls-guard]'].concat([].slice.call(arguments))); }

  function chunk(arr, n) {
    var out = [];
    for (var i = 0; i < arr.length; i += n) out.push(arr.slice(i, i + n));
    return out;
  }

  // EÃ©n HTTP-call voor maximaal BATCH_MAX skus + BATCH_MAX variants.
  // Resolved-object draagt een 'ok'-vlag:
  //   ok:true  = endpoint heeft geantwoord; skus/variants zijn autoritatief.
  //   ok:false = time-out of fout; GEEN data => caller moet kaarten ONGEMOEID laten (fail-open).
  function fetchStockChunk(skus, variants) {
    if (!skus.length && !variants.length) return Promise.resolve({ ok: true, skus: {}, variants: {} });
    var params = [];
    if (skus.length) params.push('skus=' + encodeURIComponent(skus.join(',')));
    if (variants.length) params.push('variants=' + encodeURIComponent(variants.join(',')));
    var url = ENDPOINT + '?' + params.join('&');
    return new Promise(function (resolve) {
      var resolved = false;
      var done = function (val) { if (resolved) return; resolved = true; resolve(val); };
      var timer = setTimeout(function () { warn('fetch timeout, fail-open'); done({ ok: false, skus: {}, variants: {} }); }, FETCH_TIMEOUT_MS);
      fetch(url, { method: 'GET', cache: 'no-store', mode: 'cors' })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (data) {
          clearTimeout(timer);
          // Endpoint geeft skus/variants als LEGE ARRAY terug wanneer die set niet bevraagd is;
          // normaliseer naar object zodat present-key checks kloppen.
          var s = (data && data.skus && !Array.isArray(data.skus)) ? data.skus : {};
          var v = (data && data.variants && !Array.isArray(data.variants)) ? data.variants : {};
          done({ ok: true, skus: s, variants: v });
        })
        .catch(function (e) { clearTimeout(timer); warn('fetch error, fail-open', e); done({ ok: false, skus: {}, variants: {} }); });
    });
  }

  // Splitst grote sets in chunks van BATCH_MAX en voegt de antwoorden samen.
  // Een product dat NIET in het samengevoegde antwoord voorkomt (time-out/foute chunk)
  // wordt door de callers met opzet met rust gelaten i.p.v. als uitverkocht gemarkeerd.
  function fetchStock(opts) {
    var skus = opts.skus || [];
    var variants = opts.variants || [];
    if (!skus.length && !variants.length) return Promise.resolve({ ok: true, skus: {}, variants: {} });
    var skuChunks = chunk(skus, BATCH_MAX);
    var varChunks = chunk(variants, BATCH_MAX);
    var calls = [];
    var maxLen = Math.max(skuChunks.length, varChunks.length);
    for (var i = 0; i < maxLen; i++) {
      calls.push(fetchStockChunk(skuChunks[i] || [], varChunks[i] || []));
    }
    return Promise.all(calls).then(function (results) {
      var merged = { ok: true, skus: {}, variants: {} };
      results.forEach(function (r) {
        if (!r.ok) merged.ok = false;
        Object.keys(r.skus).forEach(function (k) { merged.skus[k] = r.skus[k]; });
        Object.keys(r.variants).forEach(function (k) { merged.variants[k] = r.variants[k]; });
      });
      return merged;
    });
  }

  function findVariantSkuFromProductJson() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var json = JSON.parse(scripts[i].textContent);
        var items = Array.isArray(json) ? json : [json];
        for (var j = 0; j < items.length; j++) {
          if (items[j]['@type'] === 'Product' && items[j].sku) return String(items[j].sku);
          if (items[j].offers && items[j].offers.sku) return String(items[j].offers.sku);
        }
      } catch (e) {}
    }
    var meta = document.querySelector('meta[itemprop="sku"]');
    if (meta && meta.content) return String(meta.content);
    return null;
  }

  function findAddToCartButtons(root) {
    root = root || document;
    var sels = [
      'button[name="add"]',
      'form[action="/cart/add"] button[type="submit"]',
      '.js-quick-add',
      '.product-form__submit',
      'product-form button',
      '[data-add-to-cart]',
      '.hs-card__add',
      '[data-hs-add]'
    ];
    return root.querySelectorAll(sels.join(','));
  }

  function injectStyles() {
    if (document.getElementById('qls-guard-styles')) return;
    var s = document.createElement('style');
    s.id = 'qls-guard-styles';
    s.textContent =
      '.qls-guard-hidden{display:none !important;}' +
      '.qls-guard-oos-btn{opacity:1 !important;cursor:not-allowed !important;background:var(--color-bg-gray,#eceff1) !important;border-color:var(--color-border,#d8dde0) !important;color:var(--color-text-light,#6b7280) !important;}';
    document.head.appendChild(s);
  }

  function hideCard(innerEl) {
    try {
      // Nooit cart-drawer regels verwijderen - de winkelmand is geen product-listing.
      // Deal-varianten ([DEAL], limit-1, MEGA snoepmix, Dr Pepper 12-pack) zijn in QLS
      // niet op variant-ID bekend (found:false); zonder deze guard nukte hideCard()
      // die regels uit de drawer (puur visueel, server-cart bleef intact).
      if (innerEl.closest && innerEl.closest('.candy-drawer__item')) return;
      // Nooit PDP-gallery slides/thumbs verwijderen - die dragen data-variant-id
      // puur om foto's per variant te filteren (mv_gallery), het zijn geen
      // koop-elementen. Combined-product varianten zijn in QLS onbekend
      // (found:false) waardoor hideCard() anders de hele gallery nukt.
      if (innerEl.closest && innerEl.closest('.pdp__gallery')) return;
      // Nooit de Mousse Cakes-configurator verwijderen. Die smaken zijn een
      // aparte, gekoelde productlijn die NIET in QLS staat; QLS geeft daarop
      // found:false, waardoor de fail-closed tak anders stap 1 en stap 2
      // compleet uit de pagina sloopt.
      if (innerEl.closest && innerEl.closest('.bundle-v2')) return;
      var card = innerEl.closest(CARD_SELECTORS) || innerEl;
      if (card.dataset.qlsGuardHidden === '1') return;
      card.dataset.qlsGuardHidden = '1';
      card.remove();
      log('hidden card for', innerEl.dataset.variantId || innerEl.dataset.sku);
    } catch (e) { warn('hideCard err', e); }
  }

  // Product-row tegels: NIET verbergen maar tonen als rode "Uitverkocht"
  // (i.p.v. een lege kaart zonder knop). Zelfde look als gewoon uit-voorraad.
  function markRowCardUnavailable(innerEl) {
    try {
      var card = innerEl.closest && innerEl.closest('.product-row__card');
      if (!card || card.dataset.qlsUnavailable === '1') return;
      card.dataset.qlsUnavailable = '1';
      // stock-tekst -> rode "Uitverkocht"
      var stock = card.querySelector('.product-row__card-stock');
      if (stock) stock.innerHTML = '<span class="product-row__card-stock-text product-row__card-stock-text--unavailable"><span class="product-row__card-stock-dot"></span>Tijdelijk uitverkocht</span>';
      // koopknop -> disabled rode "Uitverkocht"
      var cta = card.querySelector('.product-row__card-cta');
      if (cta) {
        cta.removeAttribute('data-variant-id');
        cta.innerHTML = '<span class="product-row__card-atc product-row__card-atc--unavailable" aria-disabled="true">Uitverkocht</span>';
      } else if (!card.querySelector('.product-row__card-atc--unavailable')) {
        var span = document.createElement('span');
        span.className = 'product-row__card-atc product-row__card-atc--unavailable';
        span.setAttribute('aria-disabled', 'true');
        span.textContent = 'Uitverkocht';
        card.appendChild(span);
      }
      log('row card -> uitverkocht', innerEl.dataset.variantId || innerEl.dataset.sku);
    } catch (e) { warn('markRowCardUnavailable err', e); }
  }

  // Bij OOS: product-row tegels tonen "Uitverkocht"; andere listings (collectie/zoek) blijven verbergen.
  function applyOOS(el) {
    if (el.closest && el.closest('.product-row__card')) markRowCardUnavailable(el);
    else hideCard(el);
  }

  function disableAddButton(btn, label) {
    try {
      if (!btn || btn.dataset.qlsGuardOos === '1') return;
      btn.dataset.qlsGuardOos = '1';
      btn.dataset.qlsGuardOriginalText = btn.textContent || '';
      btn.disabled = true;
      btn.classList.add('qls-guard-oos-btn');
      if (btn.textContent && btn.textContent.trim().length) btn.textContent = label || OOS_LABEL;
    } catch (e) {}
  }

  function handlePDP() {
    var sku = findVariantSkuFromProductJson();
    if (!sku) { log('PDP: geen SKU gevonden'); return; }
    if (isExemptSku(sku)) { log('PDP: SKU exempt (preorder/override), laat staan', sku); return; }
    log('PDP SKU:', sku);
    fetchStock({ skus: [sku] }).then(function (data) {
      // Fail-open: geen autoritatief antwoord (time-out/fout, key afwezig) => laat de PDP met rust.
      if (!Object.prototype.hasOwnProperty.call(data.skus, sku)) { log('PDP: geen autoritatief antwoord, laat staan', sku); return; }
      var s = data.skus[sku];
      // Fail-closed alleen bij een ECHT antwoord: SKU niet in QLS (found=false) of available<=0 => blokkeer.
      // Dit pakt SKUs die QLS niet kent (zoals [DEAL] dupes die alleen via Shopify drift "op voorraad" lijken).
      var blocked = !s || !s.found || s.available <= 0;
      if (!blocked) return;
      log('PDP: blocked', sku, s);
      // Voorraad-status-regel op de candy-PDP gelijktrekken met de tegel:
      // rood "Tijdelijk uitverkocht" i.p.v. groen "Op voorraad" (Shopify denkt nog op voorraad).
      var pdpStock = document.querySelector('[data-pdp-stock]');
      if (pdpStock) { pdpStock.classList.remove('pdp__bullet--in_stock', 'pdp__bullet--low'); pdpStock.classList.add('pdp__bullet--out'); }
      var pdpStockText = document.querySelector('[data-pdp-stock-text]');
      if (pdpStockText) pdpStockText.textContent = 'Tijdelijk uitverkocht';
      var btns = findAddToCartButtons(document);
      for (var i = 0; i < btns.length; i++) disableAddButton(btns[i], OOS_LABEL);
      // Plus: intercept form submit als extra zekerheid (button.disabled werkt soms niet bij theme-overrides)
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var j = 0; j < forms.length; j++) {
        forms[j].addEventListener('submit', function (e) {
          e.preventDefault(); e.stopPropagation();
          alert(OOS_ALERT);
        }, true);
      }
    });
  }

  var lastCardScan = 0;
  function handleCards(root) {
    var now = Date.now();
    if (now - lastCardScan < DEBOUNCE_MS) return;
    lastCardScan = now;
    root = root || document;

    // SKU-based cards (data-sku)
    var skuMap = {};
    var skuNodes = root.querySelectorAll('[data-sku]');
    for (var i = 0; i < skuNodes.length; i++) {
      var sku = skuNodes[i].getAttribute('data-sku');
      if (!sku) continue;
      if (isExemptSku(sku)) continue; // preorder/override: nooit als OOS markeren
      if (skuNodes[i].closest('.candy-drawer__item')) continue; // cart-drawer regels overslaan
      if (skuNodes[i].closest('.pdp__gallery')) continue; // gallery slides/thumbs: puur visueel, overslaan
      if (skuNodes[i].closest('.bundle-v2')) continue; // mousse-configurator: niet in QLS, overslaan
      if (!skuMap[sku]) skuMap[sku] = [];
      skuMap[sku].push(skuNodes[i]);
    }

    // Variant-id-based cards (data-variant-id) - Shopify standaard
    var varMap = {};
    var varNodes = root.querySelectorAll('[data-variant-id]');
    for (var j = 0; j < varNodes.length; j++) {
      var vid = varNodes[j].getAttribute('data-variant-id');
      if (!vid || !/^\d+$/.test(vid)) continue;
      if (isExemptVariant(vid)) continue; // preorder/override: nooit als OOS markeren
      if (varNodes[j].closest('.candy-drawer__item')) continue; // cart-drawer regels overslaan
      if (varNodes[j].closest('.pdp__gallery')) continue; // gallery slides/thumbs: puur visueel, overslaan
      if (varNodes[j].closest('.bundle-v2')) continue; // mousse-configurator: niet in QLS, overslaan
      if (!varMap[vid]) varMap[vid] = [];
      varMap[vid].push(varNodes[j]);
    }

    var skus = Object.keys(skuMap);
    var vids = Object.keys(varMap);
    if (!skus.length && !vids.length) return;
    log('cards: checking', skus.length, 'SKUs +', vids.length, 'variant-ids');

    fetchStock({ skus: skus, variants: vids }).then(function (data) {
      // Verzamel eerst WELKE kaarten OOS zouden worden (zonder al toe te passen).
      // Alleen producten die het endpoint AUTORITATIEF heeft beantwoord tellen mee;
      // afwezige key = time-out/foute chunk => met rust laten (fail-open).
      var checked = 0;
      var oosGroups = [];
      Object.keys(skuMap).forEach(function (sku) {
        if (!Object.prototype.hasOwnProperty.call(data.skus, sku)) return;
        checked++;
        var info = data.skus[sku];
        if (!info || !info.found || info.available <= 0) oosGroups.push(skuMap[sku]);
      });
      Object.keys(varMap).forEach(function (vid) {
        if (!Object.prototype.hasOwnProperty.call(data.variants, vid)) return;
        checked++;
        var info = data.variants[vid];
        if (!info || !info.found || info.available <= 0) oosGroups.push(varMap[vid]);
      });

      // Circuit-breaker: de guard scant alleen kaarten die Shopify als OP VOORRAAD rendert
      // (uitverkochte kaarten dragen geen data-variant-id). Als dan tÃ³ch een verdacht groot
      // deel ineens OOS zou zijn, is dat eerder een endpoint-glitch dan realiteit => NIET toepassen.
      if (checked >= 8 && oosGroups.length > checked * 0.6) {
        warn('circuit-breaker: ' + oosGroups.length + '/' + checked + ' OOS â€” verdacht, overslaan (fail-open)');
        return;
      }

      oosGroups.forEach(function (els) { els.forEach(applyOOS); });
    });
  }

  function handleCart() {
    if (!window.fetch) return;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var skus = (cart.items || []).map(function (it) { return it.sku; }).filter(Boolean);
        if (!skus.length) return;
        log('cart: checking', skus.length, 'SKUs');
        return fetchStock({ skus: skus }).then(function (data) {
          // Fail-open: bij een mislukte fetch checkout NIET blokkeren.
          if (!data.ok) { log('cart: geen autoritatief antwoord, fail-open'); return; }
          var problems = [];
          (cart.items || []).forEach(function (it) {
            if (isExemptSku(it.sku)) return; // preorder/override: checkout nooit blokkeren
            if (!Object.prototype.hasOwnProperty.call(data.skus, it.sku)) return; // onbekend antwoord -> niet blokkeren
            var info = data.skus[it.sku];
            if (!info || !info.found || info.available < it.quantity) {
              problems.push({ sku: it.sku, title: it.product_title, requested: it.quantity, available: (info ? info.available : null) });
            }
          });
          if (problems.length) {
            warn('cart problems:', problems);
            var checkoutBtns = document.querySelectorAll('[name="checkout"], button[name="checkout"], .cart__checkout, .cart-checkout, [href$="/checkout"]');
            for (var i = 0; i < checkoutBtns.length; i++) disableAddButton(checkoutBtns[i], 'Item(s) niet leverbaar');
          }
        });
      })
      .catch(function (e) { warn('cart err, fail-open', e); });
  }

  function init() {
    injectStyles();
    var path = window.location.pathname || '';
    log('init v2', path);
    if (/^\/products\//.test(path)) handlePDP();
    if (/^\/cart/.test(path)) handleCart();
    // catch-all: scan voor cards op iedere pagina
    handleCards(document);
  }

  function observeMutations() {
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(function (muts) {
      var hasAdded = false;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { hasAdded = true; break; }
      }
      if (hasAdded) handleCards(document);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); observeMutations(); });
  } else {
    init();
    observeMutations();
  }

  // JS-gerenderde productrijen (bv. "Recent bekeken") dispatchen 'cards:rendered' nadat hun
  // tegels in de DOM staan. De MutationObserver wordt dan vaak weg-gedebounced, waardoor die
  // tegels de QLS-uitverkocht-check missen. Forceer hier een verse scan (debounce bypassen).
  document.addEventListener('cards:rendered', function () {
    lastCardScan = 0;
    handleCards(document);
  });
})();
